export default __webpack_public_path__ + "static/media/fb.2fe006c2.svg";